import { Component, OnInit } from '@angular/core';
import { Publication } from '../../services/publication.service/publication';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import{CitationModal} from './pub-wrapper/citation-modal'
import { PaperTags } from '../../services/publication.service/PaperTags';
import {GroupByPipe, OrderByPipe} from 'ngx-pipes'
import { Clipboard } from "@angular/cdk/clipboard"
import { analyzeNgModules } from '@angular/compiler';
import { publicationsService } from 'src/app/services/publication.service/publication.service';
import { AnalyticsService } from 'src/app/services/analytics.service/analytics.service';


@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.less'],
  providers:[GroupByPipe,OrderByPipe]
})
export class PublicationsComponent implements OnInit {
  pub_group={}
  constructor(public pubService:publicationsService,public groupbyPipe:GroupByPipe, analyticsService:AnalyticsService){
    analyticsService.eventEmitter("read_pubs","publications","load","PubsPage")
  }

  getPubs(){
    let publications =  this.pubService.get_all_publication();
    this.pub_group = this.groupbyPipe.transform(publications,'type');
    const arrayReverseObj = 
  obj => Object.keys(obj).sort().map(key=> ({year:key,pubs:obj[key]}) );

  this.pub_group = arrayReverseObj(this.pub_group)

  return this.pub_group
  }



  // publications:Publication[];
  // ClipboardJS:any;

  // pub_group={};
  // toggle_bibtex_pub_index:number;
  // toggle_bibtex_year_index:number;
  // toggle_bibtex:{year, pub}

  // constructor(private modalService: NgbModal, private groupbyPipe:GroupByPipe,private OrderByPipe:OrderByPipe,
  //   private clipboard:Clipboard, private pubService:publicationsService) { 
    
  //   this.toggle_bibtex_pub_index=null;
  //   this.toggle_bibtex_year_index=null;
  //   this.toggle_bibtex={year:null,pub:null }
  //   // this.toggle_bibtex.year=null;
  //   // this.toggle_bibtex.pub=null;

  //   // this.all_publications();

  //   this.publications = this.pubService.get_all_publication()

  //   this.pub_group = this.groupbyPipe.transform(this.publications,'year');
  //   const arrayReverseObj = 
  // obj => Object.keys(obj).sort().reverse().map(key=> ({year:key,pubs:obj[key]}) );

  // this.pub_group = arrayReverseObj(this.pub_group)
  //   // console.log(this.pub_group);
    
  // }

  // openCitationModal(bib_entry){
  //   const modalRef = this.modalService.open(CitationModal, { size: 'xl' });
  //   modalRef.componentInstance.bibEntry = bib_entry;

  // }

 

  ngOnInit(): void {
  }

  // copy(bibtex){
  //   this.clipboard.copy(bibtex);
    
  // }


  // toggleBibtex(year_index:Number, pub_index:Number){

  //   if(this.toggle_bibtex.year==year_index && this.toggle_bibtex.pub==pub_index){
  //     this.toggle_bibtex={year:null, pub:null};
  //   }
  //   else{
  //     this.toggle_bibtex.year = year_index;
  //   this.toggle_bibtex.pub= pub_index;
  //   console.log(this.toggle_bibtex);
  //   }
    
  // }

  // getShowBibtexYearIndex(){
    
  //   return this.toggle_bibtex.year as number;
  // }
  // getShowBibtexPubIndex(){
    
  //   return this.toggle_bibtex.pub as number;
  // }


  

}
